import styled, { css } from 'styled-components'

import { mq, sizes } from '../../theme'
import A from '../A'
import ActionButton from '../ActionButton'
import Icon from '../Icon'
import { WysiwygContainer } from '../WysiwygRenderer/styled'
import _TagAge from '../Family/TagAge'

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const IntroductionHeader = styled.div`
  display: flex;
  flex-flow: 'row nowrap';
  justify-content: space-between;

  @media print {
    display: none;
  }
`

export const SwitchCourseContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: row;
  width: 100%;
  height: 5rem;
  transform: translateY(-7.5rem);
  z-index: ${({ theme }) => theme.zIndexes.minimalContent + 1};
`

export const SwitchCourseButton = styled.button<{ isActive?: boolean }>`
  cursor: pointer;
  position: relative;
  background: ${({ isActive, theme }) =>
    isActive ? theme.colors.pureWhite : theme.colors.wildSand};
  border-radius: 2rem 2rem 0 0;
  width: 100%;
  min-height: 5rem;
  box-shadow: 0 -0.8rem 1rem 0px rgb(0 0 0 / 7%);
`

export const SwitchButtonTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH2_23}
  padding: 0;
  margin: 0;

  &::first-letter {
    text-transform: uppercase;
  }
`

export const SectionTitle = styled.h2`
  ${({ theme }) => theme.textStyles.titleH2_23}
  padding: 0;
  margin: 0;

  &::first-letter {
    text-transform: uppercase;
  }

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.titleH2_30}
  }
`

export const TagAge = styled(_TagAge)`
  margin-top: 1rem;
`

export const Buttons = styled.div<{ isSwitchCourse?: boolean }>`
  align-self: flex-start;
  display: flex;
  flex-flow: 'row nowrap';

  ${({ isSwitchCourse }) =>
    isSwitchCourse &&
    css`
      width: 100%;
      justify-content: flex-end;
    `}
`

export const SwitchButton = styled(ActionButton)`
  margin-right: 1rem;
`

export const ShareButton = styled(ActionButton)`
  height: max-content;
  &:not(:last-of-type) {
    margin-right: 1rem;
  }
`
export const FavoriteButton = styled(ActionButton)`
  height: max-content;
  @media print {
    display: none;
  }
`

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4rem;

  @media ${mq(sizes.desktop)} {
    flex-direction: row;
  }

  @media print {
    margin-top: 0;
  }
`
export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media print {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 15px;
  }
`

export const DurationInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.7rem;

  @media ${mq(sizes.desktop)} {
    gap: 1.5rem;
  }

  &:not(:first-child) {
    margin-top: 0.7rem;

    @media print {
      margin: 0;
    }
  }
`

export const DurationIcon = styled(Icon)`
  display: block;
  width: 1.7rem;
  height: 1.7rem;

  @media ${mq(sizes.desktop)} {
    width: 3rem;
    height: 3rem;
  }
`
export const DurationText = styled.div`
  ${({ theme }) => theme.textStyles.text_16}

  & b {
    ${({ theme }) => theme.textStyles.text_bold_16}
  }

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_22}

    & b {
      ${({ theme }) => theme.textStyles.text_bold_22}
    }
  }
`
export const Nutrition = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 1.5rem;

  @media ${mq(sizes.desktop)} {
    margin-top: 3rem;
  }

  @media print {
    margin: 0;
  }
`

export const NutriscoreImg = styled.div`
  display: block;
  width: 7.5rem;
  height: 5rem;
  margin-right: 1.4rem;
  position: relative;

  @media ${mq(sizes.desktop)} {
    width: 9rem;
    height: 6.7rem;
    margin-right: 2rem;
  }

  @media print {
    margin: 0;
  }
`

export const NutritionalValues = styled(A)`
  display: flex;
  color: ${({ theme }) => theme.colors.pureBlack};
  ${({ theme }) => theme.textStyles.text_medium_16}
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-color: ${({ theme }) => theme.colors.pureBlack};
  text-decoration-thickness: 2px;
  text-underline-position: under;
  align-self: center;
  text-align: left;

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_medium_18}
  }
  @media print {
    display: none;
  }
`

export const NutritionalValuesPanelHeading = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  @media print {
    display: none;
  }
`

export const NutritionalValuesPanelContent = styled.div`
  display: flex;
  flex-direction: column;
  @media print {
    display: none;
  }
`

export const EnergeticValue = styled.dl`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  padding-top: 1.4rem;
  padding-bottom: 1.4rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyDD};
  font-size: 1.6rem;
  & dt {
    ${({ theme }) => theme.fonts.HelveticaNeueBold}
    position: absolute;
  }
  & dd {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    & > * {
      padding-left: 1.5rem;
      text-align: right;
    }
  }
  @media ${mq(sizes.desktop)} {
    flex: 0 0 100%;
    padding-top: 1.8rem;
    padding-bottom: 1.8rem;
    font-size: 1.8rem;
  }
`

export const List = styled.div`
  @media ${mq(sizes.desktop)} {
    display: flex;
    flex-flow: row wrap;
    margin-left: -2rem;
    margin-right: -2rem;
  }
`

export const ListItem = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  padding-top: 1.4rem;
  padding-bottom: 1.4rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.greyDD};
  font-size: 1.6rem;
  &:last-child {
    border-bottom: 0;
  }
  & dt {
    ${({ theme }) => theme.fonts.HelveticaNeueBold}
  }
  & dd {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    ${({ theme }) => theme.fonts.HelveticaNeue}
    & > * {
      padding-left: 1.5rem;
      text-align: right;
    }
  }
  @media ${mq(sizes.desktop)} {
    flex: 0 0 calc(50% - 4rem);
    padding-top: 1.8rem;
    padding-bottom: 1.8rem;
    font-size: 1.8rem;
    margin-left: 2rem;
    margin-right: 2rem;
    &:nth-last-child(2):nth-child(odd) {
      border-bottom: 0;
    }
  }
`

export const Line = styled.dl`
  width: 100%;

  & > dt {
    position: absolute;
  }

  &.secondLine {
    dt {
      ${({ theme }) => theme.fonts.HelveticaNeue}
    }
  }
`

export const IconPlateLove = styled.div`
  left: 0;
  width: 7.5rem;
  height: 7.5rem;
  margin-right: 2.5rem;
  flex-shrink: 0;

  @media ${mq(sizes.desktop)} {
    margin-right: 0rem;
    width: 12.5rem;
    height: 12.5rem;
    position: absolute;
  }
`

export const PanelTitle = styled.span`
  display: flex;
  color: ${({ theme }) => theme.colors.pureBlack};
  ${({ theme }) => theme.textStyles.text_bold_20}

  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.text_bold_32}
    margin-left: 16.5rem;
  }
`

export const About = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 3rem;

  @media ${mq(sizes.desktop)} {
    margin-top: 6rem;
  }

  @media print {
    display: none;
  }
`

export const AboutTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & span {
    ${({ theme }) => theme.textStyles.text_bold_16}

    @media ${mq(sizes.desktop)} {
      ${({ theme }) => theme.textStyles.text_bold_32}
    }
  }
`
export const AboutIcon = styled(Icon)`
  display: flex;
  width: 2.5rem;
  height: 3.5rem;
  color: ${({ theme }) => theme.colors.redMojo};
  margin-right: 1rem;

  @media ${mq(sizes.desktop)} {
    width: 3.5rem;
    height: 4.5rem;
    margin-right: 2rem;
  }
`
export const AboutContent = styled(WysiwygContainer)`
  border-left: ${({ theme }) => `0.5rem solid ${theme.colors.pink}`};
  margin-top: 0.5rem;
  margin-left: 1rem;
  padding-left: 2rem;
  max-width: 100%;

  @media ${mq(sizes.desktop)} {
    margin-top: 1.5rem;
    margin-left: 1.5rem;
    padding-left: 3.5rem;
    max-width: 69rem;
  }
`

export const RightSection = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
  margin-top: 3rem;
  flex-shrink: 0;

  @media ${mq(sizes.desktop)} {
    margin-left: 2rem;
    margin-top: 0rem;
    max-width: 49rem;
  }
  @media print {
    display: none;
  }
`

const RecipeImage = styled.div`
  position: relative;
  width: 100%;
  height: 26rem;
  overflow: hidden;
  border-radius: 1rem;

  @media ${mq(sizes.desktop)} {
    height: 32rem;
    border-radius: 2rem;
  }
`

export const RecipeImageDesktop = styled(RecipeImage)`
  display: none;

  @media ${mq(sizes.desktop)} {
    display: flex;
  }
`

export const RecipeImageMobile = styled(RecipeImage)`
  @media ${mq(sizes.desktop)} {
    display: none;
  }
`
